import React from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {InboxesTopbarTooltip} from '../../../inboxes/topbar/inboxesTopbarTooltip';

export const inboxTaskTitle = <Trans id="admin-setup-guide-title-create-inbox">Create a shared inbox</Trans>;

export const inboxTaskDescription = (
  <Trans id="admin-setup-guide-description-create-inbox">
    Have a centralized inbox for your team to access messages and collaborate in.
  </Trans>
);

export const connectChannelTaskTitle = (
  <Trans id="admin-setup-guide-title-connect-channel">Import team messages</Trans>
);

export const connectChannelTaskDescription = (
  <Trans id="admin-setup-guide-description-connect-channel">
    Manage real messages with your team by connecting a channel like email or chat.
  </Trans>
);

export const connectChannelTaskDetails = (
  <InboxesTopbarTooltip
    firstLine={
      <Trans id="q3-admin-setup-guide-details-first-line-connect-channel">
        What to expect after importing?
      </Trans>
    }
    secondLine={
      <Trans id="admin-setup-guide-details-second-line-connect-channel">
        <ul>
          <li>
            Explore Front worry-free as your team can still maintain their current workflows in your existing
            tools.
          </li>
          <li>You can disconnect anytime.</li>
        </ul>
      </Trans>
    }
  />
);

export const teammatesTaskTitle = (
  <Trans id="admin-setup-guide-title-invite-teammates">Invite teammates</Trans>
);

export const teammatesTaskDescription = (
  <Trans id="admin-setup-guide-description-invite-teammates">
    Start collaborating using comments, assignments, and shared drafts.
  </Trans>
);

export const channelTaskTitle = (
  <Trans id="admin-setup-guide-title-connect-channel">See your team&apos;s messages in Front</Trans>
);
export const channelTaskDescription = (
  <Trans id="admin-setup-guide-description-connect-channel">
    Connect a channel to start seeing messages that the team can manage together.
  </Trans>
);

export const sandboxTaskTitleV3 = <Trans id="admin-setup-guide-title-sandbox-v3">Core capabilities</Trans>;
export const sandboxTaskDescriptionV3 = (
  <Trans id="admin-setup-guide-description-sandbox-v3">
    Boost team efficiency with better collaboration and automation.
  </Trans>
);

export const sandboxAnalyticsTaskTitle = (
  <Trans id="admin-setup-guide-sandbox-analytics-title">Analytics</Trans>
);
export const sandboxAnalyticsTaskDescription = (
  <Trans id="admin-setup-guide-sandbox-analytics-description">
    Explore how analytics surfaces insights to help you make business decisions.
  </Trans>
);

export const sandboxChatTaskTitle = (
  <Trans id="admin-setup-guide-sandbox-chat-title">Live chat and knowledge base</Trans>
);
export const sandboxChatTaskDescription = (
  <Trans id="admin-setup-guide-sandbox-chat-description">
    See how features like Chat and Knowledge Base help resolve inquiries faster.
  </Trans>
);

export const sharedWorkspaceTaskTitle = (
  <Trans id="admin-setup-guide-title-create-shared-workspace">Set up shared inbox</Trans>
);
export const sharedWorkspaceTaskDescription = (
  <Trans id="admin-setup-guide-description-create-shared-workspace">
    Design your Front experience by creating your first shared inbox and workflows.
  </Trans>
);
